import { useEffect, useState } from "react";
import { useGame } from "../header/GameContext";
import FooterButton from "../footer/footerText3Button";
import "./intro.css";
import { saveToSheet } from "../../api/sheet";
import { confirmEntryCode } from "../../api/entryCode";

const generateKeyCode = () =>
  (
    Date.now().toString(36) + Math.random().toString(36).substring(2, 8)
  ).toUpperCase();

function Intro({
  handleName,
  setHandleName,
  handleName2,
  setHandleName2,
  handleName3,
  setHandleName3,
  onFinish,
  defaultPath,
}) {
  const {
    setPlayerKeyCode,
    setIntroTeamName, // ✅ GameContext 정확한 이름
    setIntroInCodeV, // ✅ GameContext 정확한 이름
    setUserRole,
    pauseTimer,
  } = useGame();

  const safeName = handleName || "";
  const safeName2 = handleName2 || "";
  const isActive = safeName.trim().length > 0;
  const isActive2 = safeName2.trim().length > 0;
  const isActive3 = handleName3;

  const handleName3_options = [
    { value: "agentX", label: "Agent X" },
    { value: "agentY", label: "Agent Y" },
  ];

  const [isLoading, setIsLoading] = useState(false);

  const handleStart = async () => {
    if (!handleName.trim()) {
      alert("팀명을 입력하세요.");
      return;
    }
    if (!handleName2.trim()) {
      alert("입장 코드를 입력하세요.");
      return;
    }
    if (!isActive3) {
      alert("역할을 선택하세요.");
      return;
    }

    const keyCode = generateKeyCode();
    setIsLoading(true);

    try {
      await confirmEntryCode(handleName2);

      // ✅ localStorage - GameContext 상수와 동일한 키로 저장
      localStorage.setItem("PLAYER_KEY_CODE", keyCode);
      localStorage.setItem("PLAYER_TEAM", handleName); // ✅ INTRO_TEAM → PLAYER_TEAM
      localStorage.setItem("PLAYER_INCODE", handleName2); // ✅ INTRO_CODE → PLAYER_INCODE
      localStorage.setItem("PLAYER_ROLE", handleName3); // ✅ USER_ROLE  → PLAYER_ROLE

      // ✅ GameContext - 정확한 함수명으로 저장
      setPlayerKeyCode(keyCode);
      setIntroTeamName(handleName); // ✅
      setIntroInCodeV(handleName2); // ✅
      setUserRole(handleName3);

      try {
        await saveToSheet({
          introTeam: handleName,
          keyCode: keyCode,
          userRole: handleName3,
        });
      } catch (sheetError) {
        console.error("시트 저장 실패:", sheetError.message);
      }

      onFinish?.({ defaultPath });
    } catch (e) {
      console.error(e);
      if (e.message === "유효하지 않은 입장코드입니다.") {
        alert("유효하지 않은 입장코드입니다.");
      } else if (e.message === "입장코드 사용횟수가 초과되었습니다.") {
        alert("사용이 불가한 입장코드입니다.");
      } else if (e.message === "사용 가능한 날짜가 아닙니다.") {
        alert("오늘 사용 가능한 입장코드가 아닙니다.");
      } else {
        alert("저장 실패. 다시 시도해주세요.");
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    pauseTimer();
  }, [pauseTimer]);

  return (
    <div>
      <div className="intro_pop_box">
        <div className="intro_pop_tc">
          <div className="intro_img"></div>
        </div>

        <FooterButton
          buttonValue={
            isLoading ? <span className="btn-spinner" /> : "미션 시작하기"
          }
          handleName={handleName}
          setHandleName={setHandleName}
          handleName2={handleName2}
          setHandleName2={setHandleName2}
          handleName3={handleName3}
          setHandleName3={setHandleName3}
          handleName3_options={handleName3_options}
          ftIdName="box_ft3"
          btnClass={`inputBtn02 mt16 ${isActive && isActive2 && isActive3 ? "active" : ""}`}
          onFinish={handleStart}
          disabled={!(isActive && isActive2 && isActive3) || isLoading}
        />
      </div>
    </div>
  );
}

export default Intro;
